<template>
  <div class="flex-center-between" >
    <div class="left flex-center">
      <img :src="logoUrl" class="logo" style="height: 0.9rem" alt="">
      <template v-if="isImitate">
        <div class="imitate-tag">{{ $t('mo-ni-jiao-yi-pan') }}</div>

         <Popover v-model="showPopover9" trigger="click" placement="bottom-start">
          <div class="menu-child-box">
            <div class="child-line flex-center-start" @click="toPath('imitate', {imitateType: 1})">
              <img :src="tradeUrl1" alt="">
              <div class="name">{{ $t('followDetail.label16') }}</div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('imitate', {imitateType: 2})">
              <img :src="tradeUrl2" alt="">
              <div class="name">{{ $t('followDetail.label17') }}</div>
            </div>
          </div>
          <template #reference>
            <div class="menu flex-center">
              {{ $t('pageTitle.trade') }} <img :src="downUrl" alt="">
            </div>
          </template>
        </Popover>
      </template>
      <template v-else>
        <div class="menu flex-center" @click="toPath('index')">{{ $t('pageTitle.index') }}</div>
        <div class="menu flex-center" @click="toPath('market')">{{ $t('pageTitle.market') }}</div>

        <Popover v-model="showPopover9" trigger="click" placement="bottom-start">
          <div class="menu-child-box enhanced-menu">
            <div class="menu-header">
              <div class="header-title">{{ $t('pageTitle.trade') }}</div>
              <div class="header-subtitle">{{ $t('menuTradeSubtitle') }}</div>
            </div>
            <div class="border"></div>
            <div class="child-line flex-center-start" @click="toPath('trade', {type: 2})">
              <div class="icon-wrapper option-icon">
                <img :src="tradeUrl1" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('followDetail.label16') }}</div>
                <div class="description">{{ $t('menuTradeOptionDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('trade', {type: 3})">
              <div class="icon-wrapper contract-icon">
                <img :src="tradeUrl2" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('followDetail.label17') }}</div>
                <div class="description">{{ $t('menuTradeContractDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('trade', {type: 1})">
              <div class="icon-wrapper spot-icon">
                <img :src="tradeUrl3" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('common.trade2') }}</div>
                <div class="description">{{ $t('menuTradeSpotDesc') }}</div>
              </div>
            </div>
          </div>
          <template #reference>
            <div class="menu flex-center">
              {{ $t('pageTitle.trade') }} <img :src="downUrl" alt="">
            </div>
          </template>
        </Popover>
        <Popover v-model="showPopover1" trigger="click" placement="bottom-start">
          <div class="menu-child-box enhanced-menu">
            <div class="menu-header">
              <div class="header-title">{{ $t('pageTitle.finance') }}</div>
              <div class="header-subtitle">{{ $t('menuFinanceSubtitle') }}</div>
            </div>
            <div class="border"></div>
            <div class="child-line flex-center-start" @click="toPath('finance')">
              <div class="icon-wrapper finance-icon">
                <img :src="financeUrl" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('jin-rong-li-cai') }}</div>
                <div class="description">{{ $t('menuFinanceFinancialDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('myPosition')">
              <div class="icon-wrapper position-icon">
                <img :src="accountUrl" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pageTitle.myPosition') }}</div>
                <div class="description">{{ $t('menuFinancePositionDesc') }}</div>
              </div>
            </div>
          </div>
          <template #reference>
            <div class="menu flex-center">
              {{ $t('pageTitle.finance') }} <img :src="downUrl" alt="">
            </div>
          </template>
        </Popover>
        <Popover v-model="showPopover6" trigger="click" placement="bottom-start" v-show="false">
          <div class="menu-child-box">
            <div class="child-line flex-center-start" @click="toPath('reward')">
              <img :src="rewardUrl" alt="">
              <div class="name">{{ $t('pageTitle.reward') }}</div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('share')">
              <img :src="shareUrl" alt="">
              <div class="name">{{ $t('index.menu3') }}</div>
            </div>
          </div>
          <template #reference>
            <div class="menu flex-center">
              {{ $t('chart_page.label2') }} <img :src="downUrl" alt="">
            </div>
          </template>
        </Popover>
      </template>
    </div>
    <div class="right flex-center">
      <!-- <div class="input flex-center-between">
        <input type="text" :placeholder="$t('account.label16')" v-model="keyword" @keydown.enter="doSearch">
        <Icon name="search" color="#777E90" size="20"></Icon>
      </div> -->

      <div class="imitate-menu flex-center" @click.stop="toPath('trade', {type: 2})" v-if="isImitate">
        <img :src="leftUrl" alt="">
        {{ $t('shi-pan-jiao-yi') }} </div>

      <div class="menu" v-show="!isLogin" @click.stop="showModal('register')">
        {{ $t('pageTitle.register') }} </div>
      <div class="menu " v-show="!isLogin" @click.stop="showModal('login')">
        {{ $t('resetPassword.login') }} </div>
      <div class="menu flex-center" v-show="isLogin">
        <Popover v-model="showPopover7" trigger="click" placement="bottom-start">
          <div class="menu-child-box enhanced-menu assets-menu">
            <div class="menu-header">
              <div class="header-title">{{ $t('zi-chan-guan-li-0') }}</div>
              <div class="header-subtitle">{{ $t('menuAssetsSubtitle') }}</div>
            </div>
            <div class="border"></div>
            <div class="child-line flex-center-start" @click="toPath('assest')">
              <div class="icon-wrapper asset-manage-icon">
                <img :src="assestUrl1" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('zi-chan-guan-li') }}</div>
                <div class="description">{{ $t('menuAssetsManageDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('account', {type: 1})">
              <div class="icon-wrapper option-account-icon">
                <img :src="assestUrl2" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pageTitle.account1') }}</div>
                <div class="description">{{ $t('menuAssetsOptionAccountDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('account', {type: 2})">
              <div class="icon-wrapper contract-account-icon">
                <img :src="assestUrl3" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pageTitle.account2') }}</div>
                <div class="description">{{ $t('menuAssetsContractAccountDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('account', {type: 3})">
              <div class="icon-wrapper spot-account-icon">
                <img :src="assestUrl4" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pageTitle.account3') }}</div>
                <div class="description">{{ $t('menuAssetsSpotAccountDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('account', {type: 4})">
              <div class="icon-wrapper finance-account-icon">
                <img :src="assestUrl5" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pageTitle.account4') }}</div>
                <div class="description">{{ $t('menuAssetsFinanceAccountDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('account', {type: 6})">
              <div class="icon-wrapper follow-account-icon">
                <img :src="assestUrl6" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pageTitle.account6') }}</div>
                <div class="description">{{ $t('menuAssetsFollowAccountDesc') }}</div>
              </div>
            </div>
          </div>
          <template #reference>
            {{ $t('zi-chan-guan-li-0') }} <img :src="downUrl" alt="">
          </template>
        </Popover>

      </div>
      <div class="menu flex-center" v-show="isLogin">
        <Popover v-model="showPopover8" trigger="click" placement="bottom-start">
          <div class="menu-child-box enhanced-menu orders-menu">
            <div class="menu-header">
              <div class="header-title">{{ $t('trade.label18') }}</div>
              <div class="header-subtitle">{{ $t('menuOrdersSubtitle') }}</div>
            </div>
            <div class="border"></div>
            <div class="child-line flex-center-start" @click="toPath('orderList', {type: 2})">
              <div class="icon-wrapper option-order-icon">
                <img :src="orderUrl1" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('qi-quan-ding-dan') }}</div>
                <div class="description">{{ $t('menuOrdersOptionOrderDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('orderList', {type: 3})">
              <div class="icon-wrapper contract-order-icon">
                <img :src="orderUrl2" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('he-yue-ding-dan') }}</div>
                <div class="description">{{ $t('menuOrdersContractOrderDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('orderList', {type: 1})">
              <div class="icon-wrapper spot-order-icon">
                <img :src="orderUrl3" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('xian-huo-ding-dan') }}</div>
                <div class="description">{{ $t('menuOrdersSpotOrderDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start"  @click="toPath('orderList', {type: 6})">
              <div class="icon-wrapper finance-order-icon">
                <img :src="orderUrl4" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('jin-rong-ding-dan') }}</div>
                <div class="description">{{ $t('menuOrdersFinanceOrderDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start"  @click="toPath('orderList', {type: 7})">
              <div class="icon-wrapper follow-order-icon">
                <img :src="orderUrl5" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('gen-dan-ding-dan') }}</div>
                <div class="description">{{ $t('menuOrdersFollowOrderDesc') }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('assestLog')">
              <div class="icon-wrapper asset-log-icon">
                <img :src="orderUrl6" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('assestLog.title') }}</div>
                <div class="description">{{ $t('menuOrdersAssetLogDesc') }}</div>
              </div>
            </div>
          </div>
          <template #reference>
            {{ $t('trade.label18') }} <img :src="downUrl" alt="">
          </template>
        </Popover>
      </div>
      <div class="user" v-show="isLogin">
        <Popover v-model="showPopover2" trigger="click" placement="bottom-start">
          <div class="menu-child-box enhanced-menu user-menu">
            <div class=" info-line">
              <div class="name">{{userName}}</div>
              <div class="desc">UID：{{uId}}</div>
            </div>
            <div class="border"></div>
            <div class="child-line flex-center-start" @click="toPath('password')">
              <div class="icon-wrapper security-icon">
                <img :src="accountUrl1" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('zhang-hao-yu-an-quan') }}</div>
                <div class="description">{{ $t('userMenuSecurityDesc') || '账号安全设置' }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('userAuth')">
              <div class="icon-wrapper auth-icon">
                <img :src="accountUrl2" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pageTitle.userAuth') }}</div>
                <div class="description">{{ $t('userMenuAuthDesc') || '身份认证管理' }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('address')">
              <div class="icon-wrapper address-icon">
                <img :src="accountUrl3" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pageTitle.address') }}</div>
                <div class="description">{{ $t('userMenuAddressDesc') || '收货地址管理' }}</div>
              </div>
            </div>
            <div class="child-line flex-center-start" @click="toPath('tradeSetting')">
              <div class="icon-wrapper setting-icon">
                <img :src="accountUrl4" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('pian-hao-she-zhi') }}</div>
                <div class="description">{{ $t('userMenuSettingDesc') || '交易偏好设置' }}</div>
              </div>
            </div>
            <div class="border"></div>
            <div class="child-line flex-center-start" @click="toLogout">
              <div class="icon-wrapper logout-icon">
                <img :src="accountUrl5" alt="">
              </div>
              <div class="content-wrapper">
                <div class="name">{{ $t('tui-chu-deng-lu') }}</div>
                <div class="description">{{ $t('userMenuLogoutDesc') || '安全退出系统' }}</div>
              </div>
            </div>
          </div>
          <template #reference>
            <img :src="userUrl" alt="">
          </template>
        </Popover>
      </div>
      <div class="menu">
        <!-- <Popover v-model="showPopover4" trigger="click" @opened="drawQrcode" placement="bottom-end">
          <div class="qrcode-box">
            <div class="label">{{ $t('sao-ma-xia-zai-app') }}</div>
            <div class="qrcode-outer">
              <div class="qrcode" id="qrcode" ref="qrcode"></div>
            </div>
          </div>
          <template #reference>
            {{ $t('xia-zai') }} </template>
        </Popover> -->

      </div>
      <div class="menu" @click="toPath('notice')">
        {{ $t('pageTitle.notice') }} </div>
      <div class="menu">
        <Popover v-model="showPopover3" trigger="click" placement="bottom-end">
          <div class="menu-child-box support-menu">
            <div class="child-line flex-center-start" v-for="(item, i) in kefuList" :key="i"  @click="chooseKefu(item)">
              <img :src="item.Avatar" alt="">
              <div class="name">{{item.Name}}</div>
            </div>
          </div>
          <template #reference>
            {{ $t('trade.menu5') }} </template>
        </Popover>

      </div>
      <div class="lang">
        <Popover v-model="showPopover5" trigger="click" placement="bottom-end">
          <div class="lang-list">
            <div class="list flex-center-between" :class="item.key == lang ? 'active' : ''" v-for="(item, i) in langArr" :key="i" @click="changeLang(item)">
              {{item.name}}
              <Icon name="success" size="16" v-show="item.key == lang"/>
            </div>
          </div>
          <template #reference>
            <img :src="langUrl" alt="">
          </template>
        </Popover>
      </div>
    </div>

    <!-- 客服iframe组件 -->
    <KefuIframe
      :visible="showKefuIframe"
      :link="currentKefuLink"
      @close="closeKefuIframe" />
  </div>
</template>
<script>
import { getToken, removeToken } from '@/utils/auth'
import { userInfo } from '@/api/user'
import { Icon, Popover  } from 'vant'
import QRCode from 'qrcodejs2'
import { getDefaultLanguage } from '@/utils/common'
import { customerList } from '@/api/setting'
import KefuIframe from '../KefuIframe.vue'
import { isQiabotNewType, openQiabotWidget, QIABOT_NEW_TYPE } from '@/utils/qiabot'

export default {
  components: {
    Icon,
    Popover,
    KefuIframe
  },
  name: 'tabbar',
  props:{
    isImitate: Boolean
  },
  data() {
    return {
      kefuList: [],
      logoUrl: require('../../assets/imgs/logo6.png'),
      downUrl: require('../../assets/imgs/icon-arrow-down.png'),
      langUrl: require('../../assets/imgs/icon-lang.png'),
      userUrl: require('../../assets/imgs/icon-user.png'),
      financeUrl: require('../../assets/imgs/icon-finance.png'),
      accountUrl: require('../../assets/imgs/icon-mine-finance.png'),
      accountUrl1: require('../../assets/imgs/icon-account1.png'),
      accountUrl2: require('../../assets/imgs/icon-account2.png'),
      accountUrl3: require('../../assets/imgs/icon-account3.png'),
      accountUrl4: require('../../assets/imgs/icon-account4.png'),
      accountUrl5: require('../../assets/imgs/icon-account5.png'),
      kefuUrl1: require('../../assets/imgs/icon-kefu1.png'),
      kefuUrl2: require('../../assets/imgs/icon-kefu2.png'),
      kefuUrl3: require('../../assets/imgs/icon-kefu3.png'),
      kefuUrl4: require('../../assets/imgs/icon-kefu4.png'),
      rewardUrl: require('../../assets/imgs/icon-reward.png'),
      shareUrl: require('../../assets/imgs/icon-invite.png'),
      assestUrl1: require('../../assets/imgs/icon-assest1.png'),
      assestUrl2: require('../../assets/imgs/icon-assest2.png'),
      assestUrl3: require('../../assets/imgs/icon-assest3.png'),
      assestUrl4: require('../../assets/imgs/icon-assest4.png'),
      assestUrl5: require('../../assets/imgs/icon-assest5.png'),
      assestUrl6: require('../../assets/imgs/icon-assest6.png'),
      orderUrl1: require('../../assets/imgs/icon-order1.png'),
      orderUrl2: require('../../assets/imgs/icon-order2.png'),
      orderUrl3: require('../../assets/imgs/icon-order3.png'),
      orderUrl4: require('../../assets/imgs/icon-order4.png'),
      orderUrl5: require('../../assets/imgs/icon-order5.png'),
      orderUrl6: require('../../assets/imgs/icon-order6.png'),
      tradeUrl1: require('../../assets/imgs/icon-trade1.png'),
      tradeUrl2: require('../../assets/imgs/icon-trade2.png'),
      tradeUrl3: require('../../assets/imgs/icon-trade3.png'),
      tradeUrl4: require('../../assets/imgs/icon-trade4.png'),
      tradeUrl5: require('../../assets/imgs/icon-trade5.png'),
      leftUrl: require('../../assets/imgs/icon-arrow-left.png'),
      isLogin: false,
      keyword: '',
      showPopover1: false,
      showPopover2: false,
      showPopover3: false,
      showPopover4: false,
      showPopover5: false,
      showPopover6: false,
      showPopover7: false,
      showPopover8: false,
      showPopover9: false,
      userName: '',
      uId: '',
      downloadUrl: '',
      lang: '',
      langArr: [
        {
          name: 'English',
          key: 'en',
        },
          // 哈萨克斯坦语
        {
          name: 'Русский',
          key: 'kk',
        },
        //   西班牙语
        {
          name: 'Español',
          key: 'es',
        },
          // 法语
        {
          name: 'Français',
          key: 'fr',
        },
        // 德语
        {
          name: 'Deutsch',
          key: 'de',
        },
        // 荷兰语
        {
          name: 'Nederlands',
          key: 'nl',
        },
        // 匈牙利语
        {
          name: 'Magyar',
          key: 'hu',
        },
        // 芬兰语
        {
          name: 'Suomi',
          key: 'fi',
        },
        // 挪威语
        {
          name: 'Norsk',
          key: 'no',
        },
          // 意大利语
        {
          name: 'Italiano',
          key: 'it',
        },
          // 葡萄牙语
        {
          name: 'Português',
          key: 'pt',
        },
          // 俄语
        {
          name: 'Pусский',
          key: 'ru',
        },
        //   土耳其语
        {
          name: 'Türkçe',
          key: 'tr',
        },
          // 韩语
        {
          name: '한국어',
          key: 'ko',
        },
          // 日语
        {
          name: '日本語',
          key: 'ja',
        },
          // 越南语
        {
          name: 'Tiếng Việt',
          key: 'vi',
        },
          // 印尼语
        {
          name: 'Bahasa Indonesia',
          key: 'id',
        },
          // 马来语
        {
          name: 'Bahasa Melayu',
          key: 'ms',
        },
          // 泰语
        {
          name: 'ภาษาไทย',
          key: 'th',
        },
          // 阿拉伯语
        {
          name: 'العربية',
          key: 'ar',
        },
          // 希伯来语
        {
          name: 'עברית',
          key: 'he',
        },
          // 印地语
        {
          name: 'हिन्दी',
          key: 'hi'
        },
        // 波兰语
        {
          name: 'Polski',
          key: 'pl',
        },
        // 斯洛伐克语
        {
          name: 'Slovenský',
          key: 'sk',
        },
        // 捷克语
        {
          name: 'Čeština',
          key: 'cs',
        },
        {
          name: '简体中文',
          key: 'zh-CN',
        },
        {
          name: '繁体中文',
          key: 'zh-TW',
        },

      ],
      // iframe客服相关
      showKefuIframe: false,
      currentKefuLink: ''
    }
  },
  computed: {
    loginStatus() {
      return this.$store.state.isLogin
    },
    footerClick() {
      return this.$store.state.footerClick
    }
  },
  watch: {
    loginStatus() {
      this.isLogin = !!getToken()
      this.init()
    },
    footerClick(val) {
      if (val == 'kefu') {
        this.showPopover3 = true
      } else if (val == 'download') {
        this.showPopover4 = true
      } else if (val == 'lang') {
        this.showPopover5 = true
      }
    }
  },
  mounted() {
    this.isLogin = !!getToken()
    this.init()
    let locale = localStorage.getItem('locale')
    const defaultLanguage = getDefaultLanguage()
    this.lang = locale ? locale : defaultLanguage

    this.initKefu()
  },
  methods: {
    init() {
      if (this.isLogin) {
        userInfo().then(res => {
          this.userName = res.data.Email || res.data.Phone
          this.uId = res.data.ID
        })
      }
    },
    initKefu() {
      customerList().then(res => {
        this.kefuList = res.data.Items
      })
    },
    doSearch() {
    },
    toPath(path, query) {
      if (path) {
        this.$router.push({
          name: path,
          query: query || {}
        })
        this.cancel()
      }
    },
    cancel() {
      this.showPopover1 = false
      this.showPopover2 = false
      this.showPopover3 = false
      this.showPopover4 = false
      this.showPopover5 = false
      this.showPopover6 = false
      this.showPopover7 = false
      this.showPopover8 = false
      this.showPopover9 = false
      this.$store.state.footerClick = ''
      this.$store.state.showModalBg = false
    },
    showModal(type) {
      const routeName = type === 'reset' ? 'resetPassword' : type
      this.$router.push({ name: routeName })
    },
    drawQrcode(){
      // 获取之前的二维码画布元素
      let qrcodeContainer = this.$refs.qrcode;

      // 清除画布内容
      while (qrcodeContainer.firstChild) {
        qrcodeContainer.removeChild(qrcodeContainer.firstChild);
      }
      let qrcode = new QRCode(this.$refs.qrcode, {
        text: this.downloadUrl,
        width: 90,
        height: 90,
        colorDark: '#0072F5',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    toLogout() {
      removeToken()
      this.$store.state.isLogin = false
      this.cancel()
      this.isLogin = false
      if (this.$route.name !== 'login') {
        this.$router.push({ name: 'login' })
      }
    },
    changeLang(data) {
      this.lang = data.key
      localStorage.setItem('locale', data.key)
      localStorage.setItem('localeName', data.name)
      this.$i18n.locale = data.key
      this.$store.state.langName = data.name
      this.$store.state.language = data.key
      this.cancel()
      // 刷新页面以确保语言切换生效
      window.location.reload()
    },
    chooseKefu(data) {
      if (isQiabotNewType(data.Type)) {
        window.localStorage.setItem('kefuType', QIABOT_NEW_TYPE)
        openQiabotWidget(data.Link).catch(error => {
          console.error('qiabot新版打开失败:', error)
        })
        this.cancel()
        return
      }
      // 如果是美洽客服，根据链接判断使用iframe还是原生方式
      if (data.Type === 'meiqia') {
        // 根据链接中是否包含chatlink.html来决定使用iframe还是原生方式
        if (data.Link && data.Link.includes('chatlink.html')) {
          // 使用iframe方式
          // 将客服链接中的域名替换为当前访问的域名
          let kefuLink = data.Link
          try {
            const currentHost = window.location.host // 获取当前域名（包含端口）
            const linkUrl = new URL(data.Link)
            linkUrl.host = currentHost // 替换域名
            kefuLink = linkUrl.toString()
            console.log("")
          } catch (e) {
            console.error('替换客服链接域名失败:', e)
            // 如果替换失败，使用原链接
            kefuLink = data.Link
          }
          console.log("kefuLink:",kefuLink)
          this.currentKefuLink = kefuLink
          this.showKefuIframe = true
          this.cancel() // 关闭下拉菜单
        } else {
          // 使用原生方式
          this.$kefu()
        }
      } else if (data.Type === 'qiabot') {
        const match = data.Link && data.Link.match(/[?&]tag=([^&]+)/)
        const tag = match ? match[1] : ''
        this.currentKefuLink = '/qiabot.html' + (tag ? '?tag=' + tag : '')
        this.showKefuIframe = true
        this.cancel()
      } else {
        this.$kefu()
      }
    },
    // 关闭客服iframe
    closeKefuIframe() {
      this.showKefuIframe = false
      this.currentKefuLink = ''
    },
    to(Type, Link) {
      let tmp = undefined
      let that = this
      if(isQiabotNewType(Type)) {
        window.localStorage.setItem('kefuType', QIABOT_NEW_TYPE)
        openQiabotWidget(Link).catch(error => {
          console.error('qiabot新版打开失败:', error)
        })
      } else if(Type == "chatwoot") {
        if(window.$chatwoot === undefined) {
          tmp = setInterval(function (){
            // that.chatwoot()
            if (window.$chatwoot !== undefined) {
              clearInterval(tmp)
              window.$chatwoot.toggle('open');
            }
          },50)
        } else {
          window.$chatwoot.toggle('open');
        }
      } else if (Type == 'meiqia') {
        this.$router.push({
          name: 'kefu'
        })
      } else {
        switch (Type) {
          case "wechat":
            Link = "weixin://" + Link
            break;
          case "qq":
            Link = "mqq://"+ Link
            break;
          case "whatsapp":
            Link = "whatsapp://send?phone="+ Link
            break;
          case "telegram":
            Link = "tg://resolve?domain="+ Link
            break;
          case "facebook":
            Link = "fb://"+ Link
            break;
          case "twitter":
            Link = "twitter://"+ Link
            break;
          case "instagram":
            Link = "instagram://"+ Link
            break;
            case "line":
            Link = "https://line.me/R/"+ Link
            break;
        }
        this.toKefuPath(Link)
      }
    },
    toKefuPath(path) {
      let a = document.createElement('a')
      a.href = path
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    chatwoot(Link){
      let that = this;
      if (Link.length === 0) {
        return;
      }
      let len = Link.indexOf("/widget");
      if (len === -1) {
        return;
      }
      var BASE_URL=Link.substr(0,len);
      let tokenlen = Link.indexOf("token=");
      let token = Link.substr(tokenlen+6);
      window.chatwootSDK.run({
        websiteToken: token,
        baseUrl: BASE_URL
      });
      that.inter = setInterval(function(){
        if(document.getElementsByClassName("woot-widget-bubble")[0] !== undefined) {
          that.show = true;
          clearInterval(that.inter);
          window.$chatwoot.toggleBubbleVisibility('hide');
        }
      },50);
    },
  }
}
</script>
